import React from 'react';
import Form from 'react-bootstrap/Form';

export default function RequiredFormLabel(props) {
    return <Form.Label {...props}>{props.children} <span className="required">*</span></Form.Label>;
};